import { wishListSharingStatusStyles } from "@insite/content-library/Components/WishListSharingStatus";
import { css } from "styled-components";

wishListSharingStatusStyles.statusText = {
    css: css`
        font-size: 14px;
    `,
};